import styled from "styled-components";
import OrnamentImg from "../../assets/images/ornament.png";

/* Paleta La Fontanella */
const colors = {
  white: "#ffffff",
  black: "#0e0e0e",
  text: "#111214",
  gold: "#8b8064",
  goldSoft: "rgba(139,128,100,0.25)",
  line: "rgba(0,0,0,0.08)",
};

export const Wrap = styled.section`
  min-height: 100dvh;
  display: grid;
  place-items: center;
`;

export const Panel = styled.div`
  position: relative;
  width: min(720px, 92vw);
  min-height: 75vh;
  background: ${colors.black};
  color: ${colors.white};
  border-radius: 28px;
  padding: 60px 40px 50px;
  box-shadow: 0 22px 60px rgba(0, 0, 0, 0.35), inset 0 0 0 2px ${colors.gold};
  isolation: isolate;

  &::after {
    content: "";
    position: absolute;
    inset: 14px;
    border-radius: 24px;
    border: 2px dashed rgba(255, 255, 255, 0.12);
    z-index: 0;
    pointer-events: none;
  }

  @media (min-width: 680px) {
    padding: 70px 60px 60px;
    min-height: 72vh;
  }

  @media (max-width: 480px) {
    padding: 50px 24px 40px;
  }
`;

export const LogoWrap = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  place-items: center;

  img {
    display: block;
    height: 100px;
    width: auto;
    filter: drop-shadow(0 6px 14px rgba(0, 0, 0, 0.35));
  }

  @media (max-width: 480px) {
    img {
      height: 100px;
    }
  }
`;

export const Title = styled.h1`
  position: relative;
  z-index: 1;
  margin: 26px 0 14px;
  text-align: center;
  font-size: clamp(20px, 4vw, 36px);
  line-height: 1.2;
  font-weight: 800;
  letter-spacing: 0.3px;
  color: ${colors.white};
`;

export const OrnDivider = styled.div`
  position: relative;
  z-index: 1;
  height: 45px;
  width: min(440px, 84%);
  margin: 22px auto 30px;
  background: url(${OrnamentImg}) center / contain no-repeat;
  opacity: 0.95;

  filter: brightness(0) saturate(100%) invert(69%) sepia(5%) saturate(948%)
    hue-rotate(6deg) brightness(92%) contrast(93%);
  /* această combinație de filtre reproduce fidel culoarea #8b8064 */
  /* 🔸 Eliminată bara aurie deasupra */
`;

export const Buttons = styled.div`
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  padding: 8px 12px;
  margin-top: 10px;

  @media (min-width: 560px) {
    grid-template-columns: 1fr 1fr;
    gap: 20px;
    padding: 8px 30px;
  }
`;

export const Btn = styled.button`
  appearance: none;
  border-radius: 14px;
  font-weight: 800;
  letter-spacing: 0.2px;
  font-size: 16px;
  padding: 16px 20px;
  cursor: pointer;
  line-height: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  transition: all 0.2s ease;

  ${({ $variant }) =>
    $variant === "primary"
      ? `
    background: ${colors.gold};
    color: #fff;
    border: 1px solid ${colors.gold};
    box-shadow: 0 10px 24px ${colors.goldSoft};
    &:hover { filter: brightness(0.98); transform: translateY(-1px); }
  `
      : `
    background: #fff;
    color: ${colors.text};
    border: 1px solid ${colors.gold};
    box-shadow: 0 8px 20px rgba(0,0,0,0.12);
    &:hover { transform: translateY(-1px); }
  `}

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 480px) {
    border-radius: 12px;
    padding: 15px 16px;
  }
`;

export const Note = styled.p`
  position: relative;
  z-index: 1;
  margin: 30px auto 0;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 14px;
`;
